import {useState} from 'react';
import {Box, Flex, Button, IconButton} from '@chakra-ui/react';
import {AiOutlineLeft, AiOutlineRight} from 'react-icons/ai';
import {
    IoDocumentsOutline,
    IoHomeOutline,
    IoCheckboxOutline,
    IoEarthOutline,
    IoTrendingUpOutline,
    IoCashOutline,
    IoPartlySunnyOutline,
    IoStatsChartOutline,
    IoAddCircleOutline, IoTimeOutline, IoMapOutline, IoSearchOutline
} from 'react-icons/io5';
import {useLocation, useNavigate} from 'react-router-dom';

const Sidebar = ({isCollapsed, setIsSidebarCollapsed}) => {
    const location = useLocation();
    const navigate = useNavigate();

    const menuItems = [
        {
            name: 'My Dashboard',
            path: '/farmer-dashboard-demo',
            icon: <IoStatsChartOutline color="gray.500" size={20}/>,
            key: 'dashboard'
        },
        {
            name: 'Satellite Imagery',
            path: '/satellite-imagery-demo',
            icon: <IoEarthOutline color="gray.500" size={20}/>,
            key: 'satellite'
        },
        // {
        //     name: 'Market Intelligence',
        //     path: '/market-intelligence/c8ddc607-d728-4dd7-9780-00c0626de725',
        //     icon: <IoTrendingUpOutline color="gray.500" size={20}/>,
        //     key: 'market'
        // },
        {
            name: 'My Financials',
            path: '/financial-analysis-demo',
            icon: <IoCashOutline color="gray.500" size={20}/>,
            key: 'financial'
        },
        {
            name: 'Weather',
            path: '/weather-info-demo',
            icon: <IoPartlySunnyOutline color="gray.500" size={20}/>,
            key: 'weather'
        },
    ];

    // Function to determine the active state of a menu item
    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <Box
            bg="gray.40"
            h="100vh"
            borderRightWidth="0.5px"
            w={isCollapsed ? '56px' : '208px'}
            transition="width 0.2s"
        >
            <Flex direction="column" h="full" p={2}>
                {/* Menu Items */}
                <Flex direction="column" flexGrow={1}>
                    {menuItems.map((item) => (
                        <Button
                            key={item.key}
                            onClick={() => navigate(item.path)}
                            justifyContent={isCollapsed ? 'center' : 'start'}
                            variant="ghost"
                            p={3}
                            w="full"
                            my={1}
                            mr={2}
                            borderRadius="md"
                            bg={isActive(item.path) ? 'gray.100' : 'transparent'} // Apply background color if active
                            _hover={{bg: 'gray.100'}} // Hover state
                            _active={{bg: 'gray.200'}} // Active state
                        >
                            {item.icon}
                            {!isCollapsed && item.name}
                        </Button>
                    ))}
                </Flex>
                <IconButton aria-label="Toggle Sidebar"
                            icon={isCollapsed ? <AiOutlineRight/> : <AiOutlineLeft/>}
                            onClick={() => setIsSidebarCollapsed(!isCollapsed)}
                            variant="ghost"
                            size="sm"
                            alignSelf="flex-start"
                            mb={16}
                >{isCollapsed ? <AiOutlineRight/> : <AiOutlineLeft/>}</IconButton>
                {/*<IconButton*/}
                {/*    aria-label="Toggle Sidebar"*/}
                {/*    icon={isCollapsed ? <AiOutlineRight/> : <AiOutlineLeft/>}*/}
                {/*    onClick={() => setIsSidebarCollapsed(!isCollapsed)}*/}
                {/*    variant="ghost"*/}
                {/*    size="sm"*/}
                {/*    alignSelf="flex-start"*/}
                {/*    mb={4}*/}
                {/*    ml={2}*/}
                {/*/>*/}
            </Flex>
        </Box>
    );
};

export default Sidebar;